import { render, staticRenderFns } from "./loading-bar.vue?vue&type=template&id=1ccb7955&"
import script from "./loading-bar.vue?vue&type=script&lang=js&"
export * from "./loading-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports